import roomTwoSix, { home as roomTwoSixHome } from './client/room-260/index'
import signeNature, { home as singeNatureHome } from './client/signe-nature/index'
import leslieEnCuisine, { home as leslieEnCuisineHome } from './client/leslie-en-cuisine/index'
import delbove, { home as delboveHome } from './client/delbove/index'
import teski, { home as teskiHome } from './client/teski/index'
import dimitriLismay, { home as dimitriLismayHome } from './client/dimitri-lismay/index'
import bettyJeane, { home as bettyJeaneHome } from './client/betty-jeane/index'
import * as clientsImages from './client/otherAssets'

export const portfolioHomeData = [
  { id: 0, ...delboveHome },
  { id: 1, ...teskiHome },
  { id: 2, ...singeNatureHome },
  { id: 3, ...leslieEnCuisineHome },
  { id: 4, ...bettyJeaneHome },
  { id: 5, ...dimitriLismayHome },
  { id: 6, ...roomTwoSixHome }
]

export const allPortfolio = {
  [delboveHome.slug]: delbove,
  [teskiHome.slug]: teski,
  [singeNatureHome.slug]: signeNature,
  [leslieEnCuisineHome.slug]: leslieEnCuisine,
  [bettyJeaneHome.slug]: bettyJeane,
  [dimitriLismayHome.slug]: dimitriLismay,
  [roomTwoSixHome.slug]: roomTwoSix
}

export const otherClients = clientsImages

export const pageData = {
  intro: (
    <>
      Découvrez les différents projets sur lesquels l'Atelier Milky a déjà eu l'occasion de travailler. Que ce soit dans
      le domaine de la beauté, de la mode ou encore du design, notre équipe met touten œuvre pour développer des projets
      de communication sur-mesure répondant aux besoins de nos clients.
    </>
  )
}
